//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { getServiceContext } from "~base/Services/ConsilioServiceContext";
import { getSettingsContext } from "~base/Settings/ConsilioSettingsContext";
import { getSopNLIntlContext } from "~jrad/Internationalization/SopNLIntlContext";
import { getSoPNLValidationContext } from "~jrad/Validation/SoPNLValidationContext";
import { getSoPNLNormalizerContext } from "~jrad/Validation/SoPNLNormalizerContext";
import { ContextWrapper } from "~base/ContextWrapper";
import SopNLTheme, {
    getSoPNLThemeByTenant,
} from "~jrad/Styling/SoPNLConsilioTheme";
import { config } from "~jrad/Internationalization/ConfigurationInfo";
import MainRouter from "./MainRouter";
import * as textCodeService from "~base/Services/TextCodeService";
import { ErrorBoundary } from "~base/Pages/Shared/ErrorBoundary";
import IRadConsilioTheme from "./Styling/Tenants/IRadConsilioTheme";

type MainProps = {
    children?: React.ReactNode;
};

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

const MainApp: React.FunctionComponent<MainProps> = (props: MainProps) => {
    return (
        <ContextWrapper
            {...props}
            theme={IRadConsilioTheme(SopNLTheme)}
            getThemeByTenant={getSoPNLThemeByTenant}
            getServiceContext={getServiceContext}
            useServerContext={true}
            loadUser={true}
            getSettingsContext={getSettingsContext}
            useScreenSharing={false}
            messages={textCodeService.textCodes()}
            getIntlContext={getSopNLIntlContext}
            currency={"EUR"}
            compatMode={true}
            useUsersPreferredCulture={true}
            enableLogoutListener={true}
            useTenantFavicons
            useTextCodeApplicationTitle
            config={config}
            getValidationContext={getSoPNLValidationContext}
            getNormalizerContext={getSoPNLNormalizerContext}
            intl={null}
            validation={null}
        >
            <ErrorBoundary catchJsErrors={true} catchPromiseErrors={true}>
                <MainRouter />
            </ErrorBoundary>
        </ContextWrapper>
    );
};

export default MainApp;
